import { lazy } from 'react';

export const Refunds = lazy(() => import('./list'));
